import * as React from "react";
import Box from "@mui/material/Box";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import useStyles from "./FmCenteredTabs.style";
import { selectIsRtl } from "../../Redux/States/General/GeneralSelectors";
import { GeneralState } from "../../Redux";
import { useSelector } from "react-redux";

interface FmCentetrredTabsProps {
  tabsNames: string[];
  tabValue: number;
  setTabValue: (val: number) => void;
}

const FmCenteredTabs = ({ tabsNames, tabValue, setTabValue }: FmCentetrredTabsProps) => {
  const classes = useStyles();
  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setTabValue(newValue);
  };

  const isRtl = useSelector(GeneralState.Selectors.selectIsRtl);

  return (
    <Box className={isRtl ? classes.containerRtl : classes.container}>
      <Tabs value={tabValue} onChange={handleChange}>
        {tabsNames.map((t: any) => (
          <Tab key={t} label={t} />
        ))}
      </Tabs>
    </Box>
  );
};

export default FmCenteredTabs;
